import Container from "@/components/ui/Container";
import SectionLabel from "@/components/ui/SectionLabel";
import ContactForm from "@/components/Forms/ContactForm";
import sphere from "@/assets/mib/sphere.webp";

export default function ContactSection() {
  return (
    <section className="relative overflow-hidden rounded-t-[30px] bg-navy-900 md:rounded-t-[50px]">
      <Container className="pt-[60px] min-[478px]:pt-[100px] xl:pt-[120px]">
        <div className="relative flex flex-col xl:grid xl:grid-cols-2 xl:gap-[60px]">
          <div className="relative z-10 flex flex-col">
            <SectionLabel>Расширяем наблюдаемость</SectionLabel>
            <h2 className="mt-5 text-[32px] font-bold leading-[1.1] text-white min-[478px]:text-[38px] md:text-[40px] xl:text-[60px] xl:leading-none xl:tracking-[-1.2px]">
              МИБ меняет подход к управлению уязвимостями
            </h2>
            <p className="mt-6 max-w-[328px] text-[16px] font-medium leading-[1.4] text-white xl:mt-[180px]">
              Покажем реальные риски в системе, которые требуют внимания
            </p>
          </div>

          <img
            src={sphere}
            alt=""
            aria-hidden="true"
            className="pointer-events-none z-0 mx-auto mt-10 w-[300px] max-w-full select-none opacity-50 animate-spin-slow motion-reduce:animate-none min-[478px]:mt-12 min-[478px]:w-[480px] md:absolute md:mx-0 md:mt-0 md:-right-[40px] md:top-[125px] md:w-[480px] xl:left-[19%] xl:right-auto xl:top-[100px] xl:w-[400px]"
          />

          <ContactForm
            subject="МИБ — Заявка на консультацию"
            source="mib_page"
            subtitle="Заполните, пожалуйста, форму для обратной связи"
            className="relative z-10 -mx-4 -mt-24 min-[478px]:-mt-16 sm:-mx-16 md:mx-0 md:mt-[330px] xl:mt-0"
          />
        </div>
      </Container>
    </section>
  );
}
